import styled from "styled-components";
import SearchInput from "~/src/components/form-components/search-input";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export const StyledSearchInput = styled(SearchInput)`
  margin-right: ${STYLE_CONSTS.UNIT_3};
  width: 378px;
`;
